import { render, staticRenderFns } from "./SearchLayerPlugin.vue?vue&type=template&id=2b098c44&scoped=true"
import script from "./SearchLayerPlugin.vue?vue&type=script&lang=ts"
export * from "./SearchLayerPlugin.vue?vue&type=script&lang=ts"
import style0 from "./SearchLayerPlugin.vue?vue&type=style&index=0&id=2b098c44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b098c44",
  null
  
)

export default component.exports